import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import styles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
import ALur_asa from "assets/img/alur ASA.png"
import Button from 'components/CustomButtons/Button';

const useStyles = makeStyles(styles);

export default function Clue() {
  const classes = useStyles();
  return (
    <div className={classes.section}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8}>
          <h2 className={classes.title}>Proses Melakukan Permohonan</h2>
          <h5 className={classes.description}>
          Untuk melakukan permohonan pembuatan surat, ada baiknya memahami alur proses berikut.
          </h5>
        </GridItem>
      </GridContainer>
      <div>
        <GridContainer justify="center">
          <GridItem md={10}>
            <Card style={{width: "100%"}}>      
              <CardBody>
                  <img src={ALur_asa} alt="Alur asa" style={{width:'100%'}} />
                  <Button href={ALur_asa} color="primary" round>Download</Button>
              </CardBody>
            </Card>
          </GridItem>         
         
        </GridContainer>
      </div>
    </div>
  );
}
